import api from '../config/api';
import { saveDownload } from '../utils/saveDownload';

// User API Service
const userAPI = {
  // Get user profile
  getProfile: async () => {
    try {
      const res = await api.get('/user/profile');
      return res.data;
    } catch (error) {
      console.error('Error fetching profile:', error);
      throw error;
    }
  },

  // Get all saved addresses
  getAddresses: async () => {
    try {
      const res = await api.get('/user/address');
      return res.data;
    } catch (error) {
      console.error('Error fetching addresses:', error);
      throw error;
    }
  },

  // Add new address
  addAddress: async (addressData) => {
    try {
      const res = await api.post('/user/address', addressData);
      return res.data;
    } catch (error) {
      console.error('Error adding address:', error);
      throw error;
    }
  },

  // Update existing address
  updateAddress: async (addressId, addressData) => {
    try {
      const res = await api.put(`/user/address/${addressId}`, addressData);
      return res.data;
    } catch (error) {
      console.error('Error updating address:', error);
      throw error;
    }
  },

  // Delete address
  deleteAddress: async (addressId) => {
    try {
      const res = await api.delete(`/user/address/${addressId}`);
      return res.data;
    } catch (error) {
      console.error('Error deleting address:', error);
      throw error;
    }
  },

  // Get payment methods
  getPaymentMethods: async () => {
    try {
      const res = await api.get('/user/payment-methods');
      return res.data;
    } catch (error) {
      console.error('Error fetching payment methods:', error);
      throw error;
    }
  },

  // Remove a saved card (cards are saved on the Stripe customer during checkout)
  removePaymentMethod: async (id) => {
    const res = await api.delete(`/user/payment-methods/${id}`);
    return res.data;
  },

  // GDPR: download a copy of the account's personal data as a JSON file
  downloadMyData: async () => {
    saveDownload(await api.get('/user/export', { responseType: 'blob' }), 'waseeny-data.json');
  },

  // Get refunds
  getRefunds: async () => {
    try {
      const res = await api.get('/web-user/refunds');
      return res.data;
    } catch (error) {
      console.error('Error fetching refunds:', error);
      throw error;
    }
  },

  // Get favorite restaurants
  getFavoriteRestaurants: async () => {
    try {
      const res = await api.get('/user/favorites/restaurants');
      return res.data;
    } catch (error) {
      console.error('Error fetching favorite restaurants:', error);
      throw error;
    }
  },

  // Get favorite products
  getFavoriteProducts: async () => {
    try {
      const res = await api.get('/user/favorites/products');
      return res.data;
    } catch (error) {
      console.error('Error fetching favorite products:', error);
      throw error;
    }
  },

  // Get wallet details
  getWallet: async () => {
    try {
      const res = await api.get('/wallet');
      return res.data;
    } catch (error) {
      console.error('Error fetching wallet:', error);
      throw error;
    }
  },

  // Add money to wallet
  addMoney: async (amount) => {
    try {
      const res = await api.post('/wallet/add/money', { amount });
      return res.data;
    } catch (error) {
      console.error('Error adding money to wallet:', error);
      throw error;
    }
  },

  // Request a manual refund
  requestRefund: async (orderId, note, amount, items = []) => {
    try {
      const res = await api.post('/user/refund-request', { orderId, note, amount, items });
      return res.data;
    } catch (error) {
      console.error('Error requesting refund:', error);
      throw error;
    }
  }
};

export default userAPI;
